export const kycConstants = {
  KYC_SET_INVESTOR_ID: 'KYC_SET_INVESTOR_ID',
  KYC_SET_ACTIVE_TAB: 'KYC_SET_ACTIVE_TAB'
};
